import { render, staticRenderFns } from "./DmqUserIcon.vue?vue&type=template&id=3de44cee&"
import script from "./DmqUserIcon.vue?vue&type=script&lang=ts&"
export * from "./DmqUserIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports